// Bilingual SEO content (Spanish primary, English secondary — key for the studio).
export const SITE = {
  name: "Grabarte",
  domain: "https://grabarte360.com",
  ogImage: "https://grabarte360.com/wp-content/uploads/2024/01/EVG_HEADER.jpeg",
};

export const SEO = {
  home: {
    title: {
      es: "Grabarte | Agencia de marketing y productora audiovisual en Madrid",
      en: "Grabarte | Marketing Agency & Film Production Studio in Madrid, Spain",
    },
    description: {
      es: "Agencia de marketing, comunicación y eventos y estudio de desarrollo audiovisual en Madrid. Producción de documentales, series, películas, programas y branded content. 20 años creando negocio e historias.",
      en: "Marketing, communication & events agency and audiovisual development studio in Madrid, Spain. Production of documentaries, series, films, TV programs and branded content. 20 years building business and stories.",
    },
    keywords: {
      es: "agencia de marketing Madrid, productora audiovisual Madrid, estudio de desarrollo audiovisual, producción de documentales, branded content, marketing de fidelización, referral marketing",
      en: "film production company Madrid, Spanish production studio, documentary production company, co-production documentaries Spain, branded content studio, marketing agency Spain",
    },
  },
  marketing: {
    title: {
      es: "Agencia de marketing, comunicación y eventos en Madrid | Grabarte",
      en: "Marketing, Communication & Events Agency in Madrid | Grabarte",
    },
    description: {
      es: "Estrategia, comunicación digital, eventos, gastronomía, fidelización y referral marketing para grandes marcas. Agencia de marketing en Madrid con resultados medibles.",
      en: "Strategy, digital communication, events, gastronomy, loyalty and referral marketing for major brands. A Madrid-based marketing agency with measurable results.",
    },
    keywords: {
      es: "agencia de marketing Madrid, agencia de eventos Madrid, marketing de fidelización, referral marketing España, eventos de marca, gastronomía y lifestyle",
      en: "marketing agency Madrid Spain, brand events agency, loyalty marketing, referral marketing, experiential marketing, gastronomy brand experiences",
    },
  },
  audiovisual: {
    title: {
      es: "Productora audiovisual y estudio de desarrollo en Madrid | Grabarte",
      en: "Film & TV Production Studio in Madrid, Spain | Documentaries, Series & Films | Grabarte",
    },
    description: {
      es: "Estudio de desarrollo audiovisual en Madrid: producción propia y coproducción de documentales, películas, series, programas de TV y branded content. De la idea al estreno.",
      en: "Audiovisual development studio in Madrid, Spain: in-house production and international co-production of documentaries, films, series, TV programs and branded content. From idea to release.",
    },
    keywords: {
      es: "productora audiovisual Madrid, estudio de desarrollo audiovisual, producción de documentales, coproducción de películas, producción de series, programas de televisión, branded content",
      en: "film production company Madrid Spain, documentary production company Spain, international co-production, TV series production, Spanish production studio, branded content production, development studio",
    },
  },
  proyectos: {
    title: { es: "Proyectos y casos de éxito | Grabarte", en: "Work & Case Studies | Grabarte" },
    description: {
      es: "Casos de éxito en marketing, comunicación, eventos y producción audiovisual: American Express, Telefónica, Orange, Marqués de Riscal, Mediaset y más.",
      en: "Selected work in marketing, communication, events and audiovisual production: American Express, Telefónica, Orange, Marqués de Riscal, Mediaset and more.",
    },
    keywords: {
      es: "casos de éxito marketing, portfolio productora audiovisual, proyectos branded content, documentales producidos",
      en: "production studio portfolio, branded content case studies, documentary portfolio Spain, marketing case studies",
    },
  },
  actualidad: {
    title: { es: "Actualidad y blog | Grabarte", en: "News & Blog | Grabarte" },
    description: {
      es: "Noticias, tendencias e investigación sobre marketing de recomendación, fidelización, comunicación y producción audiovisual en España.",
      en: "News, trends and research on referral marketing, loyalty, communication and audiovisual production in Spain.",
    },
    keywords: {
      es: "blog marketing de recomendación, observatorio referral marketing España, tendencias fidelización",
      en: "referral marketing blog, loyalty marketing trends, audiovisual production news Spain",
    },
  },
  contacto: {
    title: { es: "Contacto | Agencia Grabarte en Madrid", en: "Contact | Grabarte, Madrid" },
    description: {
      es: "¿Tienes un proyecto de marca o una historia que contar? Contacta con Grabarte, agencia de marketing y estudio de producción audiovisual en Madrid.",
      en: "Got a brand project or a story to tell? Get in touch with Grabarte, a marketing agency and film production studio in Madrid, Spain.",
    },
    keywords: {
      es: "contacto agencia de marketing Madrid, contacto productora audiovisual Madrid",
      en: "contact film production company Madrid, contact marketing agency Spain, co-production enquiry",
    },
  },
};

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Grabarte",
  url: SITE.domain + "/",
  logo: SITE.domain + "/brand/isotipo-white.svg",
  description:
    "Marketing, communication & events agency and audiovisual development studio in Madrid, Spain.",
  foundingDate: "2010",
  telephone: "+34915327701",
  email: "info@grabarte360.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Avenida Miguel Delibes, 32",
    addressLocality: "Madrid",
    postalCode: "28052",
    addressCountry: "ES",
  },
  areaServed: "ES",
};
